import React from 'react';
import { connect } from 'react-redux';
import selectUserPermission from 'common/selectors/selectUserPermission';
import permissionRequiredAll from 'common/utils/validation/permissionRequiredAll';
import permissionRequiredAny from 'common/utils/validation/permissionRequiredAny';

// --- SPECIALIZED COMPONENT ---

function AuthorizeViewRequiredAll({ requiredPermission = [], children }) {
  return (
    <AuthorizeView>
      {userPermission => {
        const isAuthorized = permissionRequiredAll({
          userPermission,
          requiredPermission,
        });

        if (typeof children === 'function') {
          return children(isAuthorized);
        }

        return isAuthorized ? children : null;
      }}
    </AuthorizeView>
  );
}

function AuthorizeViewRequiredAny({ requiredPermission = [], children }) {
  return (
    <AuthorizeView>
      {userPermission => {
        const isAuthorized = permissionRequiredAny({
          userPermission,
          requiredPermission,
        });

        if (typeof children === 'function') {
          return children(isAuthorized);
        }

        return isAuthorized ? children : null;
      }}
    </AuthorizeView>
  );
}

// --- GENERIC CORE COMPONENT AND MAIN EXPORT ---

@connect(state => ({ userPermission: selectUserPermission(state) }))
export default class AuthorizeView extends React.Component {
  static RequiredAll = AuthorizeViewRequiredAll;
  static RequiredAny = AuthorizeViewRequiredAny;

  render() {
    const { userPermission, children } = this.props;
    return children(userPermission);
  }
}
